module.exports = __webpack_public_path__ + "img/missionaries25_2019_7-7-2021.ad857f19.jpg";